var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.avaliacao)?_c('VideoPlayAcademy'):(_vm.avaliacao)?_c('AvaliacaoAcademy'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }